export const AI_CHAT_AGENT_HOST: string | undefined = import.meta.env
  .VITE_AI_CHAT_AGENT_HOST

/**
 * Feature flag for the new streaming AI chat (octopus-chat-agent, OCT-4799).
 *
 * Resolved at call time so it can be toggled from the console without a
 * reload: `localStorage.setItem('aiChatV2', 'true' | 'false')` overrides the
 * build-time default; `localStorage.removeItem('aiChatV2')` restores it.
 * The agent host is required for the flag to be on.
 */
export const isAiChatV2Enabled = (): boolean => {
  const override = window.localStorage.getItem('aiChatV2')

  if (override !== null) {
    return override === 'true'
  }

  return (
    import.meta.env.VITE_AI_CHAT_V2 === 'true' && Boolean(AI_CHAT_AGENT_HOST)
  )
}

/**
 * Max length of one user message, mirrors `CONTENT_MAX_LENGTH` of the chat
 * agent's `POST /chat` (longer content is rejected with 400). Enforced in the
 * input so the request can never hit that limit.
 */
export const AI_CHAT_MESSAGE_MAX_LENGTH = 10_000
